import * as actionTypes from "../action-types";

const initialState = {
  //HACK for Dev! Remove me please
  // ----------------------------------
  // accountNumber: "1000009",
  // commodityType: "E",
  // connectionPoint: "60010147902",
  // credentials: true,
  // customerNumber: "1000009",
  // firstName: "Fiona",
  // maxDate: "2022-11-08",
  // minDate: "2022-10-31",
  // overdue: 0,
  // postCode: "3012",
  // siteAddress: "12 First ST West Footscray VIC 3012 ",
  // sureName: "Savage",
  // valid: true,
  // ----------------------------------

  isAuthenticated: false,
  access_token: null,
  expiration: null,
  error: {},
  loading: false
}

const authReducer = (state = initialState, { type, payload }) => {
  
  switch (type) {
    case actionTypes.AUTH_START:
      return { ...state, loading: true }
    case actionTypes.AUTH_SUCCESS:
      return { ...state, ...payload }
    case actionTypes.AUTH_RESET:
      return { ...state, ...initialState }
    case actionTypes.AUTH_FAIL:
      return { 
        ...state, 
        loading: false,
        access_token: null,
        expiration: null,
        error: {...payload}, 
      }
    case actionTypes.ON_PROCEED_RESET:
      return { 
        ...state, 
        loading: false,
        access_token: null,
        expiration: null,
        isAuthenticated: false,
        error: {},
      }
    case actionTypes.API_UNAUTHORIZED:
      return { 
        ...state, 
        isAuthenticated: false,
        access_token: null,
        expiration: null,
        error: {...payload}, 
      }
    default:
      return state
  }
}

export default authReducer